import {Component, OnInit, AfterViewChecked, ElementRef, ViewChild, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators, FormArray, FormControl} from '@angular/forms';
import {ChatMsg} from '../../modele/chatModel';
import {NGXLogger} from "ngx-logger";
import {ChatService} from "../../services/chat.service";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-messenger',
    templateUrl: './messenger.component.html',
    styleUrls: ['./messenger.component.scss']
})
export class MessengerComponent implements OnInit, OnDestroy {
    chatFormGroup: FormGroup;
    chatRoomJoinFormGroup: FormGroup;
    chatRoomLeaveFormGroup: FormGroup;
    messageBuffer: Array<ChatMsg> = [];
    @ViewChild('scrollMe') private myScrollContainer: ElementRef;

    private subscriptions: Subscription = new Subscription();
    private log_prefix = this.constructor.name + ":";

    constructor(private _formBuilder: FormBuilder,
                private logger: NGXLogger,
                private chat: ChatService) {

        this.subscriptions.add(this.chat.getMessageListAsSubject().subscribe(chatMessages => {
            this.messageBuffer = chatMessages;
        }))
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    ngOnInit(): void {
        this.chatFormGroup = this._formBuilder.group(
            {
                msg: [''],
            });
        this.chatRoomJoinFormGroup = this._formBuilder.group(
            {
                roomId: [''],
            });
        this.chatRoomLeaveFormGroup = this._formBuilder.group(
            {
                roomId: [''],
            });
        this.scrollToBottom();
    }

    ngAfterViewChecked() {
        this.scrollToBottom();
    }

    scrollToBottom(): void {
        try {
            this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
        } catch (err) {
        }
    }

    writeChatMessage() {
        let message = this.chatFormGroup.value.msg;
        if (message != null) {
            this.chat.sendChatMessage(message);
            this.chatFormGroup.reset();
        }
    }

    joinChatRoom() {
        let roomId = "room-" + this.chatRoomJoinFormGroup.value.roomId;
        this.chat.joinChatRoom(roomId);
        this.chatRoomJoinFormGroup.reset();
    }

    leaveChatRoom() {
        let roomId = "room-" + this.chatRoomLeaveFormGroup.value.roomId;
        this.chat.leaveChatRoom(roomId);
        this.chatRoomLeaveFormGroup.reset();
    }
}
